import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';

import AccountAssignmentObjectDetail from '../AccountAssignmentObjectDetail/AccountAssignmentObjectDetail';
import HeaderDetail from '../HeaderDetail/HeaderDetail';
import AccountAssignmentObjectForm from '../AccountAssignmentObjectForm/AccountAssignmentObjectForm';

import './ItemWell.scss';

const ItemWell = ({
  well,
  params,
  index,
  setLoading,
  disabledImputationForm,
  disabledDeleteWellButton,
  disabledAllEdition,
  showAlertWell,
  logicDeleted,
  removeWell,
  fromPteAuthorization,
  formRef,
  removeWellSelected
}) => {
  const { setFieldValue } = useFormikContext();

  const handleChangeWell = (newValues) => {
    setFieldValue(`imputationObject.wells[${index}]`, {
      ...well,
      ...newValues
    });
  };

  const handleRemoveWell = () => {
    if (logicDeleted) {
      setFieldValue(`imputationObject.wells[${index}]`, {
        ...well,
        eliminado: true
      });
      removeWellSelected(well);
    } else {
      // For now, in SDS creation
      // logical deletion is NOT being used
      removeWell(index);
    }
  };

  return (
    <div className="item-well">
      {/* Location data */}
      <HeaderDetail
        data={well}
        disabledDeleteWell={disabledDeleteWellButton || disabledAllEdition}
        handleRemoveWell={handleRemoveWell}
        showAlertWell={showAlertWell}
      />
      {/* Imputation Type and Imputation Object Form */}
      <div className="item-well well">
        <AccountAssignmentObjectForm
          data={well}
          disabledForm={disabledImputationForm || disabledAllEdition}
          form={formRef}
          fromPteAuthorization={fromPteAuthorization}
          handleChangeForm={handleChangeWell}
          imputationTypeOptions={params.optionsImputationType}
          index={index}
          setLoading={setLoading}
          wellId={well?.well?.id}
        />
        {/* Imputation Object detail */}
        {!fromPteAuthorization && <AccountAssignmentObjectDetail data={well} />}
      </div>
    </div>
  );
};

ItemWell.propTypes = {
  well: PropTypes.shape().isRequired,
  params: PropTypes.shape({
    optionsImputationType: PropTypes.arrayOf(PropTypes.shape())
  }),
  index: PropTypes.number.isRequired,
  setLoading: PropTypes.func,
  disabledImputationForm: PropTypes.bool,
  disabledDeleteWellButton: PropTypes.bool,
  disabledAllEdition: PropTypes.bool,
  showAlertWell: PropTypes.bool,
  logicDeleted: PropTypes.bool,
  removeWell: PropTypes.func,
  fromPteAuthorization: PropTypes.bool,
  formRef: PropTypes.shape({}),
  removeWellSelected: PropTypes.func
};

ItemWell.defaultProps = {
  params: {
    optionsImputationType: []
  },
  setLoading: () => {},
  disabledImputationForm: false,
  disabledDeleteWellButton: false,
  disabledAllEdition: false,
  showAlertWell: false,
  logicDeleted: true,
  removeWell: () => {},
  fromPteAuthorization: false,
  formRef: {},
  removeWellSelected: () => {}
};

export default ItemWell;
